exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-sub-header[data-v-2671abcc] {\n  background-color: #f7f7f8;\n  padding: 0.5em 1em 0.3em;\n  margin-bottom: 0.4em;\n}\n.nav-sub-header.add-inline-block[data-v-2671abcc] {\n  display: inline-block;\n}\n", ""]);

// exports
